module.exports = __webpack_public_path__ + "static/img/owner_bg1.eec8128.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rule/owner_bg1.jpg
// module id = wjZN
// module chunks = 1